export enum VALIDATION_PATTERNS {
  ONLY_LETTERS = '^[a-zA-Z ]*$',
  ONLY_WHOLE_NUMBERS = '^[0-9]*$',
  URL = `^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\-\\._~:/?#[\\]@!\\$&'\\(\\)\\*\\+,;=.]+$`,
  PRICE = "^\\d{0,8}(\\.\\d{1,2})?$"
}
